import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary/5 via-background to-accent/5 py-20 lg:py-32 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-10 w-32 h-32 bg-primary rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-40 h-40 bg-accent rounded-full blur-3xl"></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="space-y-8"
          >
            <div className="space-y-6">
              <div className="flex items-center space-x-3">
                <div className="flex items-center justify-center w-12 h-12 bg-primary rounded-xl">
                  <Icon name="Building2" size={24} color="white" strokeWidth={2} />
                </div>
                <span className="text-primary font-semibold text-lg">About Endosurgery</span>
              </div>
              
              <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-text-primary leading-tight">
                Leading Malaysia's
                <span className="text-primary block">Medical Innovation</span>
              </h1>
              
              <p className="text-lg lg:text-xl text-text-secondary leading-relaxed max-w-2xl">
                Since 2012, Endosurgery Sdn Bhd has been Malaysia's trusted partner in delivering 
                cutting-edge endoscopic and surgical solutions to healthcare professionals nationwide.
              </p>
            </div>

            {/* Key Stats */}
            <div className="grid grid-cols-2 lg:grid-cols-3 gap-6">
              <div className="text-center lg:text-left">
                <div className="text-3xl lg:text-4xl font-bold text-primary">12+</div>
                <div className="text-sm text-text-secondary font-medium">Years Experience</div>
              </div>
              <div className="text-center lg:text-left">
                <div className="text-3xl lg:text-4xl font-bold text-primary">500+</div>
                <div className="text-sm text-text-secondary font-medium">Healthcare Partners</div>
              </div>
              <div className="text-center lg:text-left col-span-2 lg:col-span-1">
                <div className="text-3xl lg:text-4xl font-bold text-primary">100%</div>
                <div className="text-sm text-text-secondary font-medium">GDPMD Certified</div>
              </div>
            </div>

            {/* Certification Badge */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.3 }}
              className="inline-flex items-center space-x-3 bg-success/10 border border-success/20 rounded-full px-6 py-3"
            >
              <Icon name="Shield" size={20} color="var(--color-success)" />
              <span className="text-success font-semibold">GDPMD Certified Distributor</span>
              <Icon name="CheckCircle" size={16} color="var(--color-success)" />
            </motion.div>
          </motion.div>

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative"
          >
            <div className="relative rounded-2xl overflow-hidden shadow-medical-hover">
              <Image
                src="/assets/images/about1.jpg"
                alt="Modern medical facility with advanced endoscopic equipment"
                className="w-full h-96 lg:h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent"></div>
            </div>
            
            {/* Floating Card */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.5 }}
              className="absolute -bottom-6 left-4 bg-card border border-border rounded-xl p-6 shadow-medical-hover max-w-xs"
            >
              <div className="flex items-center space-x-3 mb-3">
                <div className="flex items-center justify-center w-10 h-10 bg-accent/10 rounded-lg">
                  <Icon name="Award" size={20} color="var(--color-accent)" />
                </div>
                <div>
                  <div className="font-semibold text-text-primary">Excellence Award</div>
                  <div className="text-sm text-text-secondary">Healthcare Innovation 2024</div>
                </div>
              </div>
              <p className="text-sm text-text-secondary">
                Recognized for outstanding contribution to Malaysian healthcare technology.
              </p>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;